import React from 'react';

interface CurrentlyReadingCardProps {
  coverUrl: string;
  title: string;
  author: string;
  progress: number; // 0-1
  currentPage: number;
  totalPages: number;
  startedOn: string;
  onContinue: () => void;
  onReadingList: () => void;
  className?: string;
}

const CurrentlyReadingCard: React.FC<CurrentlyReadingCardProps> = ({
  coverUrl, title, author, progress, currentPage, totalPages, startedOn, onContinue, onReadingList, className
}) => (
  <div className={`bg-white rounded-lg p-4 shadow-sm h-full ${className || ''}`}>
    <div className="flex items-start space-x-4">
      {/* Book Cover */}
      <img
        src={coverUrl}
        alt={title}
        className="w-32 h-48 object-cover rounded-lg shadow-sm"
      />
      {/* Book Details */}
      <div className="flex-1">
        <h2 className="text-lg font-medium text-gray-900">{title}</h2>
        <p className="text-sm text-gray-500">By {author}</p>
        {/* Progress Bar */}
        <div className="mt-4">
          <div className="flex justify-between text-sm text-gray-600 mb-1">
            <span>Progress</span>
            <span>{currentPage} / {totalPages} pages</span>
          </div>
          <div className="h-2 bg-gray-200 rounded-full">
            <div
              className="h-2 bg-green-500 rounded-full"
              style={{ width: `${Math.round(progress * 100)}%` }}
            />
          </div>
        </div>
        <p className="mt-2 text-sm text-gray-500">Started on {startedOn}</p>
        {/* Action Buttons */}
        <div className="mt-4 flex space-x-3">
          <button className="px-4 py-2 bg-gray-900 text-white rounded-lg flex items-center" onClick={onContinue}>
            <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Continue Reading
          </button>
          <button className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 flex items-center" onClick={onReadingList}>
            <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
            </svg>
            Reading List
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default CurrentlyReadingCard; 